export const Types = {
  GET_DAILY_CODE: 'GET_DAILY_CODE',
  GET_TELEGRAM_DAILY_CODE : 'GET_TELEGRAM_DAILY_CODE',
  GET_TELEGRAM_DAILY_CODE_DETAIL : 'GET_TELEGRAM_DAILY_CODE_DETAIL',
}
